// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "@rescript/std/lib/es6/js_array.js";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var title = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.marginLeft("auto"),
      BsCssJs$PrezzeeRibbon.marginRight("auto"),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(2)),
      BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(2)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(70))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))]),
      BsCssJs$PrezzeeRibbon.selector("h1, h2, h3, h4, h5, h6", [
            BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.white),
            BsCssJs$PrezzeeRibbon.textAlign("center"),
            BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.fontWeight("semiBold")),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, Js_array.concat(Theme__Typography$PrezzeeRibbon.Styles.style1_, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(50))])),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, Theme__Typography$PrezzeeRibbon.Styles.style2_)
          ]),
      BsCssJs$PrezzeeRibbon.selector("strong", [BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Common.tangerine)])
    ]);

var Styles = {
  title: title
};

function FeatureBlock__Title(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    title,
                    className$1
                  ])
            });
}

var make = FeatureBlock__Title;

export {
  Styles ,
  make ,
}
/* title Not a pure module */
